/**
 * Mega Menu Cards — Keyboard Navigation & Accessibility
 * Minimal footprint: works with existing HeaderMenu/MainMenu web components.
 */
(function () {
  'use strict';

  const DESKTOP_BP = 1000;

  /**
   * Handle keyboard navigation within mega-menu-cards containers.
   * - Arrow keys navigate between cards
   * - Escape closes the parent dropdown
   * - Enter/Space toggles accordions
   */
  function initMegaMenuCards() {
    document.querySelectorAll('.mega-menu-cards').forEach(function (menu) {
      menu.addEventListener('keydown', handleMenuKeydown);
    });
  }

  function handleMenuKeydown(e) {
    var key = e.key;
    var target = e.target;

    if (key === 'Escape') {
      // Close parent details (the mega-menu dropdown)
      var parentDetails = target.closest('details[id^="Details-HeaderMenu-"]');
      if (parentDetails) {
        parentDetails.removeAttribute('open');
        var summary = parentDetails.querySelector('summary');
        if (summary) {
          summary.focus();
          summary.setAttribute('aria-expanded', 'false');
        }
      }
      e.preventDefault();
      return;
    }

    // Arrow navigation among cards within the grid
    if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'ArrowLeft' || key === 'ArrowRight') {
      var container = target.closest('.mega-menu-cards__grid');
      if (!container) return;

      var focusable = Array.from(
        container.querySelectorAll(
          'a.mega-menu-cards__card, summary.mega-menu-cards__card, .mega-menu-cards__sub-list a'
        )
      );

      var idx = focusable.indexOf(target);
      if (idx === -1) {
        // target might be inside a card
        var card = target.closest('.mega-menu-cards__card');
        idx = focusable.indexOf(card);
      }
      if (idx === -1) return;

      var nextIdx = idx;
      if (key === 'ArrowDown' || key === 'ArrowRight') {
        nextIdx = Math.min(idx + 1, focusable.length - 1);
      } else {
        nextIdx = Math.max(idx - 1, 0);
      }

      if (nextIdx !== idx) {
        focusable[nextIdx].focus();
        e.preventDefault();
      }
    }
  }

  /**
   * Sync ARIA attributes on accordion toggles inside mega-menu cards.
   * Exclusive accordion: only one open at a time per grid.
   */
  function initAccordionAria() {
    document.querySelectorAll('.mega-menu-cards__accordion').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      summary.addEventListener('click', function (e) {
        // If about to open, close all siblings first
        if (!details.open) {
          var grid = details.closest('.mega-menu-cards__grid');
          if (grid) {
            grid.querySelectorAll('.mega-menu-cards__accordion[open]').forEach(function (other) {
              if (other !== details) {
                other.removeAttribute('open');
                var otherSummary = other.querySelector('summary');
                if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
              }
            });
          }
        }
      });

      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }

  /**
   * Shopify Theme Editor: Re-initialize on section/block events.
   */
  function onEditorEvent() {
    initMegaMenuCards();
    initAccordionAria();
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMegaMenuCards();
      initAccordionAria();
    });
  } else {
    initMegaMenuCards();
    initAccordionAria();
  }

  // Shopify Theme Editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', onEditorEvent);
    document.addEventListener('shopify:block:select', onEditorEvent);
  }
})();
